exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-link[data-v-49d5ebe6]:not([href]){margin:0;cursor:pointer;text-decoration:underline}.vue-link[data-v-49d5ebe6]:not([href]):hover{text-decoration:none}p.vue-link[data-v-49d5ebe6]{margin:0}", ""]);

// exports
